"use strict";

import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import WebTimeoutSettings from "./WebTimeoutSettings.jsx";
import LockoutSettings from "./LockoutSettings.jsx";
import PasswordSettings from "./PasswordSettings.jsx";
import actions from "newApp/actions/SettingsActions";
import Settings from "newApp/entities/Settings";
import SettingsValidationObject from "newApp/entities/SettingsValidaionObject";

export class AccountSettings extends React.Component {
    constructor (props) {
        super(props);
    }

    render () {
        if (!this.props.settings || this.props.settings == null)
            return null;
        return (
            <div id="AccountSettings" className="col-md-12">
                <h4>Account Settings</h4>
                <div className="horizontal-line"/>
                <WebTimeoutSettings webTimeout={this.props.settings.webTimeout}
                    disabled={this.props.settings.settingsLocks.webTimeout}
                    setWebTimeout={this.props.setWebTimeout}
                />

                <LockoutSettings accountLockoutPolicy={this.props.settings.accountLockoutPolicy}
                    settingsLocks={this.props.settings.settingsLocks}
                    setAccountLockoutInterval={this.props.setAccountLockoutInterval}
                    setAccountLockoutThreshold={this.props.setAccountLockoutThreshold}
                />

                <PasswordSettings passwordPolicy={this.props.settings.passwordPolicy}
                    validationObject={this.props.validationObject}
                    settingsLocks={this.props.settings.settingsLocks}
                    setPasswordMaximumAge={this.props.setPasswordMaximumAge}
                    setPasswordMinimumLength={this.props.setPasswordMinimumLength}
                    allowPasswordAlphabeticalCharacters={this.props.allowPasswordAlphabeticalCharacters}
                    setPasswordAlphabeticalCharactersNumber={this.props.setPasswordAlphabeticalCharactersNumber}
                    setPasswordNumericCharactersNumber={this.props.setPasswordNumericCharactersNumber}
                    allowPasswordUppercaseCharacters={this.props.allowPasswordUppercaseCharacters}
                    allowPasswordNumericCharacters={this.props.allowPasswordNumericCharacters}
                    allowPasswordLowercaseCharacters={this.props.allowPasswordLowercaseCharacters}
                    allowPasswordPunctuationOrOtherCharacters={this.props.allowPasswordPunctuationOrOtherCharacters}
                    setPasswordPunctuationOrOtherCharactersNumber={this.props.setPasswordPunctuationOrOtherCharactersNumber}
                    setPasswordLowercaseCharactersNumber={this.props.setPasswordLowercaseCharactersNumber}
                    setPasswordUppercaseCharactersNumber = {this.props.setPasswordUppercaseCharactersNumber}
                />
            </div>
        );
    }
}

AccountSettings.propTypes = {
    settings: PropTypes.instanceOf(Settings),
    getOrganizationSettings: PropTypes.func,
    setPasswordPunctuationOrOtherCharactersNumber: PropTypes.func,
    allowPasswordPunctuationOrOtherCharacters: PropTypes.func,
    setPasswordMaximumAge: PropTypes.func,
    setWebTimeout: PropTypes.func,
    setAccountLockoutInterval: PropTypes.func,
    setAccountLockoutThreshold: PropTypes.func,
    validationObject: PropTypes.instanceOf(SettingsValidationObject)
};

const mapStateToProps = state => ({
    settings: state.settingsState.settings,
});

const mapDispatchToProps = (dispatch) => {
    return ({
        setWebTimeout: (value) => dispatch(actions.setWebTimeout(value)),
        setAccountLockoutInterval: (value) => dispatch(actions.setAccountLockoutInterval(value)),
        setAccountLockoutThreshold: (value) => dispatch(actions.setAccountLockoutThreshold(value)),
        setPasswordPunctuationOrOtherCharactersNumber: (value) => dispatch(actions.setPasswordPunctuationOrOtherCharactersNumber(value)),
        allowPasswordPunctuationOrOtherCharacters: (value) => dispatch(actions.allowPasswordPunctuationOrOtherCharacters(value)),
        setPasswordMaximumAge: (value) => dispatch(actions.setPasswordMaximumAge(value)),
        setPasswordMinimumLength: (value) => dispatch(actions.setPasswordMinimumLength(value)),
        allowPasswordAlphabeticalCharacters: (value) => dispatch(actions.allowPasswordAlphabeticalCharacters(value)),
        setPasswordAlphabeticalCharactersNumber: (value) => dispatch(actions.setPasswordAlphabeticalCharactersNumber(value)),
        setPasswordNumericCharactersNumber: (value) => dispatch(actions.setPasswordNumericCharactersNumber(value)),
        allowPasswordUppercaseCharacters: (value) => dispatch(actions.allowPasswordUppercaseCharacters(value)),
        allowPasswordNumericCharacters: (value) => dispatch(actions.allowPasswordNumericCharacters(value)),
        allowPasswordLowercaseCharacters: (value) => dispatch(actions.allowPasswordLowercaseCharacters(value)),
        setPasswordLowercaseCharactersNumber: (value) => dispatch(actions.setPasswordLowercaseCharactersNumber(value)),
        setPasswordUppercaseCharactersNumber: (value) => dispatch(actions.setPasswordUppercaseCharactersNumber(value))
    });
};

export default connect(mapStateToProps, mapDispatchToProps)(AccountSettings);
